import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        list_partners: {
          setting: {
            tabs: {
              contact_information: {
                tab_name: 'TAB_NAME',
                email: 'CONTACT_EMAIL',
                telegram: 'CONTACT_TELEGRAM',
                ms_teams: 'CONTACT_MS_TEAMS',
                whatsapp: 'CONTACT_WHATSAPP',
                phone_number: 'CONTACT_PHONE',
                agree_receive_emails: 'CONTACT_AGREE_RECEIVE_EMAILS',
                language_of_communication: 'LANGUAGE_OF_COMMUNICATION',
                language_of_communication_description: 'LANGUAGE_OF_COMMUNICATION_DESCRIPTION',
              },
            },
          },
        },
      },
    },
  }));
}
